import React from 'react';

interface ImageViewerProps {
  src: string;
  alt?: string;
  title?: string;
  maxHeight?: number;
}

const ImageViewer: React.FC<ImageViewerProps> = ({ src, alt = 'Question image', title, maxHeight = 360 }) => {
  return (
    <div className="image-viewer" style={{ textAlign: 'center' }}>
      {title && <div className="image-title" style={{ marginBottom: 8 }}>{title}</div>}
      <img 
        src={src} 
        alt={alt} 
        style={{ 
          maxWidth: '100%',
          maxHeight: maxHeight,
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
        }}
      />
    </div>
  );
};

export default ImageViewer;


